// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevels } from '../app/core/logging/log-levels.enum';

export const environment: any = {
  production: false,
  notificationsInterval: 900000,
  jwtTimeoutHeadsUpInSeconds: 300,
  uploadMaxFilesize: 500000000,
  targetLanguageLimit: 10,
  log: {
    logLevel: LogLevels.Error,
    logWithDate: true,
    logToConsole: true,
    logToWebAPI: true,
    logToLocalStorage: false,
  },
  baseUrl: 'https://holger-rest.dev-leginda.de/api/',
  // baseUrl: 'http://localhost:8081/api/',
  //url to new backend
  api: 'https://holger-laravel.dev-leginda.de/api',
  login: 'https://holger-angular.dev-leginda.de/login',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
